var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9135 6.04617L20.9116 24.1848C20.9116 24.4138 20.8206 24.6335 20.6586 24.7955C20.4966 24.9574 20.2769 25.0484 20.0479 25.0484H7.09165C6.86257 25.0484 6.64287 24.9574 6.48089 24.7954C6.31891 24.6335 6.22791 24.4138 6.22791 24.1847V9.93294L10.9795 5.18233H20.0498C20.1632 5.18233 20.2755 5.20467 20.3803 5.24808C20.4851 5.2915 20.5804 5.35513 20.6606 5.43534C20.7408 5.51556 20.8044 5.61079 20.8478 5.7156C20.8912 5.8204 20.9136 5.93273 20.9135 6.04617Z",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04749 10.3648H11.0352L10.9793 5.18233",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5933 18.3592C14.4595 18.3592 15.1617 17.657 15.1617 16.7908C15.1617 15.9246 14.4595 15.2224 13.5933 15.2224C12.7271 15.2224 12.0249 15.9246 12.0249 16.7908C12.0249 17.657 12.7271 18.3592 13.5933 18.3592Z",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2878 21.9117L14.6937 20.7703L15.7047 20.3515L16.7988 20.8716L17.7811 19.8893L17.261 18.7952L17.6798 17.7842L18.8212 17.3783V15.9892L17.6798 15.5833L17.261 14.5723L17.7811 13.4782L16.7989 12.4959L15.7048 13.016L14.6937 12.5973L14.2878 11.4558H12.8987L12.4928 12.5972L11.4818 13.016L10.3877 12.4959L9.40547 13.4782L9.92555 14.5723L9.50679 15.5833L8.36536 15.9892V17.3783L9.50677 17.7842L9.92553 18.7952L9.40545 19.8893L10.3877 20.8716L11.4818 20.3515L12.4928 20.7702L12.8744 21.9117H14.2878Z",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20893 22.9572H4.47775C4.24868 22.9572 4.02898 22.8662 3.867 22.7043C3.70501 22.5423 3.61401 22.3226 3.61401 22.0935V7.84177L8.36565 3.09116H17.4359C17.5493 3.09116 17.6616 3.11351 17.7664 3.15692C17.8712 3.20033 17.9665 3.26396 18.0467 3.34418C18.1269 3.4244 18.1905 3.51963 18.2339 3.62443C18.2773 3.72924 18.2996 3.84156 18.2996 3.955L18.2977 5.18233",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52957 20.8661H1.86374C1.63466 20.8661 1.41497 20.7751 1.25298 20.6131C1.091 20.4511 1 20.2314 1 20.0023V5.75061L5.75164 1H14.8219C14.9353 1 15.0476 1.02234 15.1524 1.06576C15.2572 1.10917 15.3525 1.1728 15.4327 1.25302C15.5129 1.33323 15.5765 1.42846 15.6199 1.53327C15.6633 1.63807 15.6856 1.7504 15.6856 1.86383L15.6837 3.02582",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateVector);
export default __webpack_public_path__ + "static/media/CreateVector.3e0fdb34d6886148ea23ecf780600034.svg";
export { ForwardRef as ReactComponent };